import { MDBBtn, MDBDatatable, MDBIcon } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { UpdateFreshdeskProfile, getMisc } from '../../../apiclients/streamsapi_bridge';
import DeleteProfileUser from '../../../views/popups/freshdesk/DeleteProfileUser';
import AddUsersToFreshdeskProfile from '../../../views/popups/misc/AddUsersToFreshdeskProfile';
import PopupLoader from '../../../views/popups/PopupLoader';
import PopupLoaderNew from '../../../views/popups/PopupLoaderNew';
import SaveChanges from '../../topviews/saveCancel';


function APIUser({
  profileInfo,
  profileInfoObj,
  setSuccessMessage,
  setIsloading,
  setEdited
}) {

  const [addUserProfile, setAddUserProfile] = useState(false);
  const addUserToggle = () => setAddUserProfile(!addUserProfile);
  const [teamMembers, setteamMembers] = useState([]);
  const [sourceUsers, setSourceUsers] = useState([]);
  const [updateUsers, setUpdateUsers] = useState([]);
  const [isAddedUsers, setIsAddedUsers] = useState(false);
  const [agentid, setagentid] = useState("");
  const deleteToggle = () => setDeleteUserProfile(!deleteUserProfile);
  const [deleteUserProfile, setDeleteUserProfile] = useState(false);
  const addFreshRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);


  const navigate = useNavigate();
  const { t, i18n } = useTranslation();




  function handleClick() {
    addFreshRef.current.click();
  }





  const {
    register,
    control,
    formState: { isDirty, dirtyFields, errors },
    setValue,
    watch,
    reset,
    handleSubmit,
  } = useForm({
    defaultValues: {
      update_users: [],
    },
  });


  const handleDelete = (memObj) => {
    // console.log(`deleting ${JSON.stringify(memObj)}`);
    setagentid(memObj.agentid);
    deleteToggle();
  };

  const { fields } = useFieldArray({
    control,
    name: "update_users",
  });

  let proccessdRows = [];
  fields.map((member, index) => {
    proccessdRows.push({
      member: member,
      user: member.username,
      email: member.emailid,
      notify_popup: (
        <>
          <label className="switch" onClick={(e) => e.stopPropagation()}>
            <input
              className="form-control"
              type="checkbox"
              id="AllowUsersCallerID"
              checked={watch(`update_users.${index}.notify_popup`)}
              name="manage_cid"
              onChange={(e) => {
                setValue(
                  `update_users.${index}.notify_popup`,
                  e.target.checked,
                  { shouldDirty: true }
                );
                setValue(`update_users.${index}.userid`, member.agentid, {
                  shouldDirty: true,
                });
              }}
            />
            <span className="slider round"></span>
          </label>
        </>
      ),
      remove: (
        <>
          <div className="d-flex">
            <div
              className="custom-hover-bg ms-3 p-1 cursor-pointer deleteToolTip"
              onClick={(e) => {
                e.preventDefault();
                handleDelete(member);
              }}
            >
              <MDBIcon className="fs-5" far icon="trash-alt" color="primary" />
            </div>
          </div>
        </>
      ),
    });
  });

  const actionData = {
    columns: [
      { label: "Name", field: "user" },
      { label: "Email ID", field: "email" },
      { label: "FreshDesk Notification Pop-up", field: "notify_popup", sort :false},
      { label: "Remove", field: "remove", sort: false },
    ],
    rows: proccessdRows
  };

  useEffect(() => {
    if (Object.keys(profileInfo ?? {}).length > 0) {
      setteamMembers(profileInfo?.users)
      console.log(`profileInfo?.users inside useEffect is ::: ${JSON.stringify(profileInfo?.users)}`)
      reset({
        update_users: profileInfo?.users
      })
      fetchProfileFreeUsers();
    }
  }, [profileInfo])

  async function fetchProfileFreeUsers() {
    let UserList = [],
      apiResponse = {};
    setIsloading(true);
    apiResponse = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["freshdesk_info"] }
    );
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    if (apiResponse.status === 200) {
      UserList = await apiResponse.json();

      UserList = UserList?.misc?.freshdesk_info?.non_api_users ?? [];
      console.log(`Profile Free UserList ::::: ${JSON.stringify(UserList)}`);
      setSourceUsers(UserList);
    } else {
    }
  }


  useEffect(() => {
    if (updateUsers.length > 0 && isAddedUsers) {
      console.log("update User ::::::::::: " + JSON.stringify(updateUsers));
      const userInfo = updateUsers.map((user) => ({
        userid: user.agentid,
        notify_popup: user.notify_popup ? user.notify_popup : false,
      }));
      sendUpdateAPIRequest("add_users", userInfo);
      setIsAddedUsers(false);
    }
  }, [updateUsers, isAddedUsers]);

  async function sendUpdateAPIRequest(keyName, userInfo) {
    try {
      const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);

      setIsloading(true);
      let update = {
        reqid: 127,
        siteid: siteid,
        [keyName]: userInfo,
        profileid: profileInfo.profileid,
      };

      console.log(
        "reques for sendUpdateAPIRequest  :::: " + JSON.stringify(update)
      );
      let deleteFilter = await UpdateFreshdeskProfile(update);
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      let deleteMsg = await deleteFilter.json();
      console.log("Response...  ::::::::: " + JSON.stringify(deleteMsg));
      // console.log(deleteMsg);
      if (deleteMsg.status == "Failed") {
        localStorage.setItem(
          "user_create_f",
          "Something went wrong, Please try again after sometime"
        );
        // onClose();
        window.location.href = "/apidetails";
      } else if (deleteMsg.status == "success") {
        console.log("Response inside else if ...  ::::::::: " + JSON.stringify(deleteMsg));
        localStorage.setItem("s_message", deleteMsg.message);
        // setSuccessMessage(deleteMsg.message);
        navigate("/apidetails", {
          state: { tab: "tab2", profileInfo: profileInfoObj },
        });

        window.location.reload();
      }
    } catch (error) { }
  }


  function closeSave(e) {
    reset();
  }

  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isSave);
  
  }, [isSave])


  const onSubmit = async (data) => {
    console.log("dirtyFields.update_users :::: " + JSON.stringify(dirtyFields.update_users));
    const modifiedListKey = dirtyFields.update_users;
    const modifiedListData = data.update_users;
    let modifiedField = [];
    modifiedListKey.forEach((field, index) => {
      if (field && field.notify_popup !== undefined) {
        modifiedField.push({
          userid: modifiedListData[index].userid,
          notify_popup: modifiedListData[index].notify_popup,
        });
      }
    });
    console.log("modifiedField :::: " + JSON.stringify(modifiedField));
    sendUpdateAPIRequest('update_users', modifiedField)

  };

  return (
    <>
      <div className="actionbar">
        <MDBBtn
          onClick={addUserToggle}
        >
          <MDBIcon className='me-2' fas icon="plus" size="sm" />
          Add User
        </MDBBtn>
      </div>
      <div className="apiUsersdataTable">
        <MDBDatatable search hover data={actionData}
          sortField="Name" maxHeight="63vh" />
      </div>


      {isSave && (
        <SaveChanges
          onClose={closeSave}
          isdirtyFields={isSave}
          onSave={(e) => {
            e.preventDefault();
            handleSubmit(onSubmit)();
          }}
        />
      )}

      {addUserProfile && (
        <PopupLoaderNew
          title="Add User"
          size="lg"
          content={
            <>
              <AddUsersToFreshdeskProfile
                selectedUsers={teamMembers}
                sourceUsers={sourceUsers}
                setUpdateUsers={setUpdateUsers}
                setIsAddedUsers={setIsAddedUsers}
                onClose={addUserToggle}
                ref={addFreshRef}
                setIsloading={setisLoading}
              />
            </>
          }
          onShow={setAddUserProfile}
          onClose={addUserToggle}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}

      {deleteUserProfile && (
        <PopupLoader
          title={t("RemoveUser")}
          content={
            <DeleteProfileUser
              agentid={agentid}
              profileInfoObj={profileInfoObj}
              profileInfo={profileInfo}
              onClose={deleteToggle}
              setSuccessMessage={setSuccessMessage}
            />
          }
          onShow={setDeleteUserProfile}
          onClose={deleteToggle}
        />
      )}
    </>
  )
}

export default APIUser;
